import { useEffect } from "react";
import TagManager from "react-gtm-module";
import { getStoredUtm } from '../utils/utm';
import EmailForm from "./EmailForm/EmailForm";
import styles from "./Contact.module.css";
import SEO from "./SEO";

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  name: "ווטרלס - Waterless",
  description: "משתנות ללא מים - פתרון ירוק וחסכוני לעסקים ומוסדות",
  url: "https://waterless.co.il",
  logo: "https://waterless.co.il/assets/images/waterlessLogo.png",
  image: "https://waterless.co.il/assets/images/waterlessLogo.png",
  telephone: "+972-54-4494384",
  email: "waterless.israel@gmail.com",
  address: {
    "@type": "PostalAddress",
    streetAddress: "צבי רוזנבלט 19",
    addressLocality: "תל אביב",
    postalCode: "68151",
    addressCountry: "IL",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 32.0667,
    longitude: 34.7833,
  },
  openingHoursSpecification: {
    "@type": "OpeningHoursSpecification",
    dayOfWeek: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday"],
    opens: "08:00",
    closes: "21:00",
  },
  priceRange: "$$",
};

function Contact({ title }) {
  useEffect(() => {
    window.scrollTo(0, 0);
    TagManager.dataLayer({ dataLayer: { event: "pageview", pagePath: "/contact", pageTitle: title } });
  }, [title]);

  return (
    <main className={styles.page} dir="rtl">
      <SEO
        title="צור קשר | ווטרלס משתנות ללא מים | הצעת מחיר חינם והתקנה"
        description="צרו קשר עם ווטרלס לקבלת הצעת מחיר למשתנות ללא מים לעסק או למוסד. טלפון: 0544494384. ייעוץ מקצועי, התקנה ושירות בכל הארץ, ללא התחייבות."
        path="/contact"
        structuredData={localBusinessSchema}
      />
      <div className={styles.container}>
        <header className={styles.heading}>
          <h1>הצעת מחיר למשתנות ללא מים</h1>
          <p>ספרו לנו בקצרה על העסק או המבנה, ונחזור אליכם לבדיקת התאמה.</p>
        </header>
        <div className={styles.columns}>
          <EmailForm formLocation="contact" />
          <section className={styles.details} aria-labelledby="contact-details-title">
            <h2 id="contact-details-title">פרטי יצירת קשר</h2>
            <dl>
              <div><dt>טלפון ליצירת קשר</dt><dd><a href="tel:0544494384" dir="ltr">0544494384</a></dd></div>
              <div><dt>אימייל</dt><dd><a href="mailto:waterless.israel@gmail.com" dir="ltr">waterless.israel@gmail.com</a></dd></div>
              <div><dt>מיקום</dt><dd>צבי רוזנבלט 19, תל אביב</dd></div>
              <div><dt>שעות עבודה</dt><dd>ראשון - חמישי 08:00 - 21:00</dd></div>
            </dl>
            <a href="https://wa.me/972525970820" target="_blank" rel="noopener noreferrer" className={styles.whatsapp}
              onClick={() => TagManager.dataLayer({ dataLayer: { event: "whatsapp_click", form_location: "contact", ...getStoredUtm() } })}>
              דברו איתנו בוואטסאפ
            </a>
          </section>
        </div>
        <iframe className={styles.map}
          title="מיקום משרדי ווטרלס — צבי רוזנבלט 19, תל אביב"
          src="https://www.google.com/maps?q=%D7%A6%D7%91%D7%99%20%D7%A8%D7%95%D7%96%D7%91%D7%9C%D7%98%2019%20%D7%AA%D7%9C%20%D7%90%D7%91%D7%99%D7%91&output=embed"
          width="100%" height="320" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
    </main>
  );
}

export default Contact;
